var React = require('react');

function Security (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.9,16.7C75,16.7,62.5,15,50,5C40,15,26.7,16.7,18.9,16.7c-3.9,0-6.4-0.4-6.4-0.4v21.5C12.5,82.7,50,95,50,95\n\ts37.5-12.3,37.5-57.3V16.2C87.5,16.2,85.4,16.7,81.9,16.7z M45.3,65L29.4,48.1l4.7-5.6l11.2,8l23.4-17.3l4.2,3.8L45.3,65z"}));
}

Security.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 100 102.9","style":{"enableBackground":"new 0 0 100 102.9"},"xmlSpace":"preserve"};

module.exports = Security;

Security.default = Security;
